import { Router } from './../../configs/routes';
import styles from '../../styles/home/carousalCard.scss';
import cx from 'classnames';
import Button from '../ui/button';
import { handleTrack } from '../../utils/trackActions';
import { formatRupee } from '../../utils/commonUtils';

interface Props {
  dashboardData: any;
}

const DashboardCard = (props: Props) => {
  const { dashboardData } = props;

  const showDashboard = e => {
    const path = '/save/dashboard/portfolio';
    handleTrack({
      label: e.target
        ? `hero_button_${e.target.textContent}`
        : 'button_go_to_dashboard',
      url: path,
    });
    Router.pushRoute(path, { shallow: true });
  };

  return (
    <div
      className={cx(
        'column medium-10 medium-offset-1 large-8 large-offset-2 mb30'
      )}
    >
      <div
        className={cx('center clearfix', styles['dashboard-card-container'])}
      >
        <div className={cx('columns medium-8 small-12', styles['data-box'])}>
          <div className={cx('row')}>
            <div
              className={cx(
                styles['dashboard-item'],
                'columns small-4 text--md'
              )}
            >
              <div className="font--grey">Total Investment</div>
              <span className={cx(styles['dashboard-item-data'])}>
                ₹
                {dashboardData.investedAmount
                  ? formatRupee(dashboardData.investedAmount, true)
                  : 0}
              </span>
            </div>
            <div
              className={cx(
                styles['dashboard-item'],
                'columns small-4 text--md'
              )}
            >
              <div className="font--grey ">Current value</div>
              <span className={cx(styles['dashboard-item-data'])}>
                ₹
                {dashboardData.currentValue
                  ? formatRupee(dashboardData.currentValue, true)
                  : 0}
              </span>
            </div>
            <div
              className={cx(
                styles['dashboard-item'],
                'columns small-4 text--md'
              )}
            >
              <div className="font--grey ">
                P&L
                <span
                  className={cx({
                    [styles['text-green']]: dashboardData.returnPercentage > 0,
                    [styles['text-red']]: dashboardData.returnPercentage < 0,
                  })}
                >
                  ({dashboardData.returnPercentage}%)
                </span>
              </div>
              <span
                className={cx(styles['dashboard-item-data'], {
                  [styles['text-green']]: dashboardData.returnPercentage > 0,
                  [styles['text-red']]: dashboardData.returnPercentage < 0,
                })}
              >
                ₹
                {dashboardData.returnValue
                  ? formatRupee(dashboardData.returnValue, true)
                  : 0}
              </span>
            </div>
          </div>
        </div>
        <div className={cx('columns medium-4 small-12 text--md')}>
          <div className={cx(styles['dashboard-item'])}>
            <Button
              label={'Go to Dashboard'}
              className={cx('s-btn s-btn--blue text--sm btn-shine')}
              onClick={showDashboard}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;



// WEBPACK FOOTER //
// ./components/home/dashboardCard.tsx